
import Gutter from '@/ui-kit/components/gutter';
import Icon from '@/ui-kit/components/icon';
import { IconType } from '@/ui-kit/components/icon/enums';
import {
  StyleSizeType,
  StyleColorSchemeType,
  StylePositionType,
  StyleFontWeightType,
} from '@/ui-kit/styles/enums';
import Typography from '@/ui-kit/components/typography';
import { TypographyType } from '@/ui-kit/components/typography/enums';

export default {
  /**
   * @component PrintComponent
   *
   * @public
   */

  name: 'PrintComponent',
  components: {
    Icon,
    Gutter,
    Typography,
  },
  data() {
    return {
      IconType,
      StyleSizeType,
      StyleColorSchemeType,
      StylePositionType,
      StyleFontWeightType,
      TypographyType,
    };
  },
  methods: {
    /**
     * Print current page.
     *
     * @private
     */

    print() {
      const content = document.getElementById('print-content');
      const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=1200');
      WinPrint.document.write('<html><head>');
      WinPrint.document.write('<link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Material+Icons|Montserrat|Open+Sans:300,400,600,700">');
      WinPrint.document.write('</head><body onload="print();close();">');
      WinPrint.document.write(content.innerHTML);
      WinPrint.document.write('</body></html>');
      // This timeout for Safari quick closing issue.
      setTimeout(() => WinPrint.document.close(), 0);
      WinPrint.focus();
    },
  },
};
